<template>
<div id="secure">
    <template>
        <b-navbar class="left-burger" centered style="background-color: #FFFFFF !important;">
            <!-- <template slot="brand">
                <b-navbar-item tag="router-link" :to="{ path: '/' }">
                    <img v-bind:src="this.schoolLogo" alt="School logo">
                </b-navbar-item>
            </template> -->
            <template :slot=templateLocation>
                <b-navbar-item href="#" class="is-hidden-mobile" v-on:click="goHome()" v-show="currentRouteName != 'Home'">
                    <img src="@/assets/img/logo.png" />
                    <!-- <img v-bind:src="this.schoolLogo" alt="School logo"> -->
                </b-navbar-item>
                <!-- <b-navbar-item v-on:click="goHome()">
                    Home
                </b-navbar-item> -->
                <b-navbar-item v-on:click="goAttendance()" v-show="currentRouteName != 'Home'">
                    Attendance
                </b-navbar-item>
                <b-navbar-item v-on:click="goLeaderboard()" v-show="currentRouteName != 'Home'">
                    Leaderboard
                </b-navbar-item>
                <b-navbar-item v-on:click="goManageQR()" v-show="currentRouteName != 'Home'">
                    QR Tag
                </b-navbar-item>
                <b-navbar-item v-on:click="goManageForms()" v-show="(currentRouteName != 'Home' &&  userType == 1)">
                    E-Form
                </b-navbar-item>
                <b-navbar-item v-on:click="goECertificate()" v-show="currentRouteName != 'Home'">
                    E-Certificate
                </b-navbar-item>
                <!-- <b-navbar-item v-on:click="goSetup()">
                    Setup
                </b-navbar-item> -->
                <b-navbar-dropdown label="Manage" collapsible  boxed  v-show="(currentRouteName != 'Home' &&  userType == 1)">
                    <b-navbar-item v-on:click="goManageClasses()">
                        Classes/Departments &amp; Users
                    </b-navbar-item>
                    <b-navbar-item v-on:click="goManageTeachers()">
                        Teachers/Supervisors
                    </b-navbar-item>
                    <b-navbar-item v-on:click="goManageBehaviors()">
                        Items
                    </b-navbar-item>
                    <b-navbar-item v-on:click="goManageNotifications()">
                        Notifications
                    </b-navbar-item>
                    <b-navbar-item v-on:click="goManageGroups()">
                        Groups
                    </b-navbar-item>
                </b-navbar-dropdown>
                <b-navbar-dropdown label="Profile" collapsible  boxed >
                    <b-navbar-item v-on:click="goSetup()" v-show="userType == 1">
                        Account
                    </b-navbar-item>
                    <b-navbar-item v-on:click="logout()">
                        Logout
                    </b-navbar-item>
                </b-navbar-dropdown>

            </template>

            <template slot="end">
                <b-navbar-item tag="div">
                    <div class="buttons">
                        <!-- <a class="button is-primary" v-on:click="clickTopRightButton()"> -->
                        <a class="button" v-on:click="goDownloadApp()">
                            <strong>Download App</strong>
                        </a>
                        <a class="button" v-on:click="clickTopRightButton()">
                            <strong>Tutorial</strong>
                        </a>
                        <b-button type="is-danger" v-on:click="goHelp()">Need Help?</b-button>
                        <!-- <a class="button" v-on:click="goHelp()">
                            <strong>Need Help?</strong>
                        </a> -->
                        <!-- <a class="button is-light" v-on:click="logout()">
                            Logout
                        </a> -->
                    </div>
                </b-navbar-item>

                <!-- <b-navbar-dropdown label="Manage" collapsible  boxed class="is-primary menu-manage" right>
                    <b-navbar-item v-on:click="goManageClasses()">
                        Classes &amp; Students
                    </b-navbar-item>
                    <b-navbar-item v-on:click="goManageTeachers()">
                        Teachers
                    </b-navbar-item>
                    <b-navbar-item v-on:click="goManageBehaviors()">
                        Behaviors
                    </b-navbar-item>
                    <b-navbar-item v-on:click="goManageNotifications()">
                        Notifications
                    </b-navbar-item>
                    <b-navbar-item v-on:click="goManageGroups()">
                        Groups
                    </b-navbar-item>
                </b-navbar-dropdown> -->
            </template>
        </b-navbar>
    </template>
    <div class="container">
        <div class="columns">
            <div class="column is-10 top-header title-bar">
                <img v-bind:src="this.schoolLogo" alt="School logo">
                <h1>{{ title }}</h1>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import "./public/style.scss";
const helper = require("../../config/helper")
import { Slide } from 'vue-burger-menu'  // import the CSS transitions you wish to use, in this case we are using `Slide`

export default {
    name: "NewTopMenu",
    components: {
        Slide
    },
    data() {
        return {
            schoolLogo: '',
            schoolName: '',
            currentRouteName: '',
            title: "",
            topRightButton: "",
            topRightButtonTooltip: "",
            templateLocation: "start",
            userType : 1,
        };
    },
    created() {
        this.currentRouteName = this.$router.currentRoute.name;
        this.schoolLogo = localStorage.getItem('schoolLogo')
        this.schoolName = localStorage.getItem('schoolName')
        this.userType = localStorage.getItem('userType')

        console.log("this.currentRouteName: " + this.currentRouteName)

        if (this.currentRouteName == "Home"){
            this.templateLocation = "end"
        }else{
            this.templateLocation = "start"
        }
        if (this.currentRouteName == "Home"){
            this.title = this.schoolName
            this.topRightButton = "Manage"
            this.topRightButtonTooltip = "Manage Database"
        }else if ((this.currentRouteName == "ManageClassesHome") || (this.currentRouteName == "ManageStudentsHome") || (this.currentRouteName == "ManageTeachersHome") || (this.currentRouteName == "ManageBehaviorsHome") || (this.currentRouteName == "ManageNotificationsHome") || (this.currentRouteName == "ManageGroupsHome")){
            this.title = "manage"
            this.topRightButton = "Tutorial"
            this.topRightButtonTooltip = "View Video Tutorial"

        }else if (this.currentRouteName == "Attendance"){
            this.title = "Today's Attendance"
            this.topRightButton = "Tutorial"
            this.topRightButtonTooltip = "View Video Tutorial"

        }else if (this.currentRouteName == "OverallAnalysis"){
            this.title = "Overall Report"
            this.topRightButton = "Tutorial"
            this.topRightButtonTooltip = "View Video Tutorial"

        }else if (this.currentRouteName == "SubmissionDetails"){
            this.title = "Submission Details"
            this.topRightButton = "Tutorial"
            this.topRightButtonTooltip = "View Video Tutorial"

        }else if (this.currentRouteName == "Leaderboard"){
            this.title = "Leaderboard"
            this.topRightButton = "Tutorial"
            this.topRightButtonTooltip = "View Video Tutorial"

        }else if (this.currentRouteName == "LeaderboardLive"){
            this.title = "Live Leaderboard"
            this.topRightButton = "Tutorial"
            this.topRightButtonTooltip = "View Video Tutorial"

        }else if (this.currentRouteName == "ManageQR"){
            this.title = "QR Tag"
            this.topRightButton = "Tutorial"
            this.topRightButtonTooltip = "View Video Tutorial"

        }else if (this.currentRouteName == "ManageFormsHome"){
            this.title = "E-FORM"
            this.topRightButton = "Tutorial"
            this.topRightButtonTooltip = "View Video Tutorial"

        }else if (this.currentRouteName == "ManageFormsEdit"){
            this.title = "EDIT E-FORM"
            this.topRightButton = "Tutorial"
            this.topRightButtonTooltip = "View Video Tutorial"

        }else if (this.currentRouteName == "ManageFormsSubmissions"){
            this.title = "E-FORM Submissions"
            this.topRightButton = "Tutorial"
            this.topRightButtonTooltip = "View Video Tutorial"

        }else if (this.currentRouteName == "UnRevoke"){
            this.title = "Unrevoke Submissions"
            this.topRightButton = "Tutorial"
            this.topRightButtonTooltip = "View Video Tutorial"

        }else if (this.currentRouteName == "TeacherActivitiesView"){
            this.title = "Teacher's Activities"
            this.topRightButton = "Tutorial"
            this.topRightButtonTooltip = "View Video Tutorial"

        }else if (this.currentRouteName == "Setup"){
            this.title = "Setup Account"
            this.topRightButton = "Tutorial"
            this.topRightButtonTooltip = "View Video Tutorial"

        }
    },
    beforeMount() {
        this.$emit("authenticated", true);
    },
    mounted() {},
    methods: {
        goHome() {
            this.$router.push({
                name: "Home"
            });
        },
        goAttendance() {
            this.$router.push({
                name: "Attendance"
            });
        },
        goOverallAnalysis() {
            this.$router.push({
                name: "OverallAnalysis"
            });
        },
        goLeaderboard() {
            this.$router.push({
                name: "Leaderboard"
            });
        },
        goManageQR() {
            this.$router.push({
                name: "ManageQR"
            });
        },
        goManageForms() {
            this.$router.push({
                name: "ManageFormsHome"
            });
        },
        goECertificate(){
            window.open("https://certificate.studentqr.com/", '_blank');
        },
        goSetup() {
            this.$router.push({
                name: "Setup"
            });
        },
        goManageClasses() {
            this.$router.push({
                name: "ManageClassesHome"
            });
        },
        goManageTeachers(){
            this.$router.push({
                name: "ManageTeachersHome"
            });
        },
        goManageBehaviors(){
            this.$router.push({
                name: "ManageBehaviorsHome"
            });
        },
        goManageNotifications(){
            this.$router.push({
                name: "ManageNotificationsHome"
            });
        },
        goManageGroups(){
            this.$router.push({
                name: "ManageGroupsHome"
            });
        },
        goDownloadApp(){
            window.open("https://www.studentqr.com/download", '_blank');
        },
        goHelp(){
            window.open("https://helpstudentqr.wasap.my", '_blank');
        },
        logout(){
            localStorage.removeItem('user')
            localStorage.removeItem('jwtToken')
            localStorage.removeItem('email')
            localStorage.removeItem('sessionID')
            localStorage.removeItem('schoolID')
            localStorage.removeItem('schoolName')
            localStorage.removeItem('schoolLogo')
            localStorage.removeItem('filterItems')
            this.$emit("authenticated", false)

            this.$router.push({
                name: "Login"
            });
        },
        clickTopRightButton(){
            window.open("https://www.studentqr.com/admin", '_blank');
            // if (this.currentRouteName == "Home"){
            //     this.$router.push({
            //         name: "ManageClassesHome"
            //     });
            // }else if ((this.currentRouteName == "ManageClassesHome") || (this.currentRouteName == "ManageStudentsHome") || (this.currentRouteName == "ManageTeachersHome") || (this.currentRouteName == "ManageBehaviorsHome") || (this.currentRouteName == "ManageNotificationsHome") || (this.currentRouteName == "Attendance") || (this.currentRouteName == "OverallAnalysis") || (this.currentRouteName == "SubmissionDetails") || (this.currentRouteName == "Leaderboard")){
            //     window.open("https://www.studentqr.com/admin", '_blank');
            // }
        }
    }
};
</script>

<style>
body{
  /* background-color: #F2F4F8; */
  background-color: #FFFFFF;
}

.top-header{
    display: flex;
    align-items: center;
}
.main-menu{
    z-index:100;
}
.main-menu img{
    width: 100px;
}
.center-item{
    margin: 0 auto;
}
.title-bar img{
    width: 110px;
    height: 110px;
    float: left;
    padding: 5px;
}
.title-bar h1{
    display: inline-block;
    font-size: 200%;
    color: #000;
    font-weight: bold;
}
.font-menu{
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 20px;
}
.bm-burger-button {
    position: fixed;
    width: 36px;
    height: 30px;
    left: 36px;
    top: 36px;
    cursor: pointer;
}
.bm-burger-bars {
  background-color: #d923d3 !important;
}
.line-style {
  position: absolute;
  height: 10%;
  left: 0;
  right: 0;
}
.cross-style {
  position: absolute;
  top: 12px;
  right: 2px;
  cursor: pointer;
}
.bm-cross {
  background: #bdc3c7;
}
.bm-cross-button {
  height: 24px;
  width: 24px;
}
.bm-menu {
  height: 100%; /* 100% Full-height */
  width: 0; /* 0 width - change this with JavaScript */
  position: fixed; /* Stay in place */
  z-index: 1000; /* Stay on top */
  top: 0;
  left: 0;
  background-color:#d923d3; /* Black*/
  overflow-x: hidden; /* Disable horizontal scroll */
  padding-top: 60px; /* Place content 60px from the top */
  transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
}
.bm-item-list {
  color: #b8b7ad;
  margin-left: 10%;
  font-size: 16px;
}
.bm-item-list > * {
  display: flex;
  text-decoration: none;
  padding: 0.5em;
}
.bm-item-list > * > span {
  margin-left: 10px;
  font-weight: 700;
  color: white;
}
.topRightButtonStyling{
    font-size: 20px;
    cursor: pointer;
}
#navbar-burger{
    margin-left: 0px;
}
.navbar-brand.left-burger {
	align-items: flex-start;
}
.left-burger .navbar-burger {
	margin-left: 0;
	margin-right: 0;
}
.menu-manage{
    margin: 10px;
    border-radius: 5px;
    border: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/NewTopMenu.vue